// extracted by mini-css-extract-plugin
export default {"DeleteGroupsDialog":"DeleteGroupsDialog_DeleteGroupsDialog__oGoDW"};